import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";

const initialState = {
  data: null,
};
export const slice = createSlice({
  name: "campaignPreview",
  initialState: _.cloneDeep(initialState),
  reducers: {
    setCampaignPreview: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setCampaignPreview } = slice.actions;

export default slice.reducer;
